const globalInitialState = {
    isLoading: false,
    tabValue: false,
    showTabs: false,
    sideMenuItems: [],
    schools: [],
    classrooms: [],
    isOpenSnackbar: false,
    snackbarMsg: ''
};

export default globalInitialState;